export enum AuthActions {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  SIGNUP = "SIGNUP",
  REQUEST_RESET_PWD = "REQUEST_RESET_PWD",
  RESET_PWD = "RESET_PWD",
  ACTIVATE_ACCOUNT = "ACTIVATE_ACCOUNT",
  REQUEST_ACTIVATION = "REQUEST_ACTIVATION",
}

export enum CheckoutActions {
  SET_ADDRESS_AS_GUEST = "SET_ADDRESS_AS_GUEST",
  SET_ADDRESS_AS_GUEST_WITH_PERSON = "SET_ADDRESS_AS_GUEST_WITH_PERSON",
  SET_DELIVERY_OPTION = "SET_DELIVERY_OPTION",
  SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD",
  CREATE_ORDER = "CREATE_ORDER",
  ADD_COUPON = "ADD_COUPON",
  DELETE_COUPON = "DELETE_COUPON",
  ABANDON_CART = "ABANDON_CART",
}

export enum ContactUsAction {
  CONTACT_US = "CONTACT_US",
}

export enum VerifyCustomerEmailAction {
  VERIFY_EMAIL = "VERIFY_EMAIL",
}

export enum CustomerAction {
  ADD_CUSTOMER_ADDRESS = "ADD_CUSTOMER_ADDRESS",
  UPDATE_CUSTOMER_ADDRESS = "UPDATE_CUSTOMER_ADDRESS",
  MARK_CUSTOMER_ADDRESS = "MARK_CUSTOMER_ADDRESS",
  REMOVE_CUSTOMER_ADDRESS = "REMOVE_CUSTOMER_ADDRESS",
  UPDATE_CUSTOMER = "UPDATE_CUSTOMER",
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  LOGOUT = "LOGOUT",
  ADD_COMPANY_ADDRESS = "ADD_COMPANY_ADDRESS",
  UPDATE_COMPANY_ADDRESS = "UPDATE_COMPANY_ADDRESS",
  MARK_COMPANY_ADDRESS = "MARK_COMPANY_ADDRESS",
  REMOVE_COMPANY_ADDRESS = "REMOVE_COMPANY_ADDRESS",
}

export enum CustomerActionType {
  UPDATE_CUSTOMER_NAME = "UPDATE_CUSTOMER_NAME",
  UPDATE_CUSTOMER_EMAIL = "UPDATE_CUSTOMER_EMAIL",
  UPDATE_CUSTOMER_PHONE = "UPDATE_CUSTOMER_PHONE",
  UPDATE_CUSTOMER_CONTACT = "UPDATE_CUSTOMER_CONTACT",
  UPDATE_CUSTOMER_ADDRESS = "UPDATE_CUSTOMER_ADDRESS",
  UPDATE_CUSTOMER_DELIVERY_ADDRESS = "UPDATE_CUSTOMER_DELIVERY_ADDRESS",
  UPDATE_CUSTOMER_BUSINESS = "UPDATE_CUSTOMER_BUSINESS",
  UPDATE_CUSTOMER_COMPANY_NAME = "UPDATE_CUSTOMER_COMPANY_NAME",
  UPDATE_CUSTOMER_VAT_NUMBER = "UPDATE_CUSTOMER_VAT_NUMBER",
  UPDATE_CUSTOMER_KVK_NUMBER = "UPDATE_CUSTOMER_KVK_NUMBER",
}

export enum SubscribeNewsletterAction {
  SUBSCRIBE = "SUBSCRIBE",
  UNSUBSCRIBE = "UNSUBSCRIBE",
}

export enum CartLineItemActions {
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  ADD = "ADD",
  CUSTOM_UPDATE = "CUSTOM_UPDATE",
  APPLY_COUPON = "APPLY_COUPON",
  REMOVE_COUPON = "REMOVE_COUPON",
  DELETE_SHIPPING_OPTION = "DELETE_SHIPPING_OPTION",
}

export enum OnbehalfActions {
  START = "START",
  END = "END",
}

export enum ClearSuccessfulOrderAction {
  CLEAR_CART = "CLEAR_CART",
}

export enum BlogActions {
  FETCH_BLOG = "FETCH_BLOG",
}
